import { Breakdown } from './fixDate.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateUtilsService {
  advanceDate(orig: Date, offsetY: number, offsetM: number, offsetD: number): Date {
    const res = new Date(
      orig.getFullYear() + (offsetY || 0),
      orig.getMonth() + (offsetM || 0),
      orig.getDate() + (offsetD || 0));
    return res;
  }

  getFormatter(config) {
    return new DateFormatter(config);
  }
}

export class DateFormatter {
  private placeholders: string[];
  private dateFormat: string;

  constructor(config) {
    if (config) {
      if (Array.isArray(config) || typeof config === 'string') {
        config = { placeholders: config };
      }
      if (typeof config === 'object') {
        this.placeholders = getPlaceholders(config.placeholders);
        this.dateFormat = config.dateFormat;
      }
    }

    if (this.placeholders === undefined) {
      this.placeholders = ['y', 'M', 'd', 'H', 'm', 's'];
    }

    if (this.dateFormat === undefined) {
      this.dateFormat = 'dd.MM.yyyy';
    }

    function getPlaceholders(placeholders) {
      let res;
      if (Array.isArray(placeholders)) {
        res = placeholders;
      } else if (typeof placeholders === 'string') {
        res = placeholders.split('');
      }
      return res;
    }
  }

  formatBreakdown(breakdown: Breakdown, dateFormat?: string) {
    dateFormat = dateFormat || this.dateFormat;
    const placeholderList = this.placeholders;
    const res = dateFormat.replace(getRegexp(placeholderList), function (all, m) {
      let replacement = m;
      switch (placeholderList.indexOf(m[0])) {
        case 0:
          replacement = 4 === m.length ? '' + breakdown.year : '' + breakdown.year % 100;
          break;
        case 1:
          replacement = 2 === m.length ? format02d(breakdown.month) : '' + breakdown.month;
          break;
        case 2:
          replacement = 2 === m.length ? format02d(breakdown.day) : '' + breakdown.day;
          break;
      }
      return replacement;
    });

    return res;

    function format02d(nr) {
      if (nr !== undefined) {
        return nr < 10 ? '0' + nr : nr.toString();
      } else {
        return '00';
      }
    }

    function getRegexp(placeholders): RegExp {
      return new RegExp('(' + placeholders.join('+|') + '+)', 'g');
    }
  }

  getFormattedDatePickerValue(datePickerValue: any): string | undefined {
    let res;
    if (datePickerValue) {
      if (datePickerValue.formatted) {
        res = datePickerValue.formatted;
      } else if (datePickerValue.date) {
        res = this.formatBreakdown(datePickerValue.date, 'dd.MM.yyyy');
      } else if (datePickerValue.jsdate) {
        const date = datePickerValue.jsdate;
        const breakdown = {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()};
        res = this.formatBreakdown(breakdown, 'dd.MM.yyyy');
      } else if (datePickerValue.singleDate && datePickerValue.singleDate.date) {
        res = this.formatBreakdown(datePickerValue.singleDate.date, 'dd.MM.yyyy');
      }
    }
    return res;
  }

}
